import React from "react";
import { Heading, HStack, IconButton, Tooltip } from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";

export const SECTION_HELP_TEXT = {
  runs: "Runs are month-wise payroll snapshots. Create a run first, process to compute payslips, then finalize to lock records.",
  ctc: "Create salary structures first, then assign a structure to each employee with effective date and optional variables.",
  compliance:
    "Configure PF/ESI/PT once, then track monthly compliance records, due dates, challan references, and filing/payment status.",
  benefits:
    "Benefits and adjustments are inputs added before payroll processing. They are picked up in payroll calculations for the effective period.",
  fnf: "Full & Final settlement captures exit payroll values like unpaid salary, leave encashment, gratuity, and deductions.",
  form16:
    "Generate Form 16 records by financial year, then update issue status and metadata for audit and employee communication.",
  bank: "Bank transfers are created from finalized runs. Review totals, preview employee rows, and track transfer status updates.",
  payslips:
    "Payslips display final payroll outputs per run. Locked payslips are finalized and should be treated as immutable records.",
};

export const CARD_HELP_TEXT = {
  createRun:
    "Set month and year, then create a run. No employee salary is paid yet until you process and finalize.",
  payrollRuns:
    "Use Process to compute values for each employee. Use Finalize only after review to lock the run.",
  createStructure:
    "Define CTC and salary components. Use formula only when a component must be derived from other components.",
  assignCompensation:
    "Map employee to a salary structure with base salary and effective date. Latest active mapping drives payroll.",
  salaryStructures:
    "Reference list of salary templates and component counts configured for this tenant.",
  compensationAssignments:
    "Shows current and historical employee compensation mappings and active status.",
  statutoryConfiguration:
    "Configure statutory percentages, wage limits, and PT slabs. Save before running monthly payroll compliance.",
  complianceRecords:
    "Track statutory liability records by month and update challan references and status (pending/filed/paid).",
  createBenefit:
    "Create approved benefits/reimbursements for an employee for the selected month and year.",
  createAdjustment:
    "Create payroll adjustments like bonus, gratuity, or arrears that affect net pay.",
  benefits: "Read-only list of employee benefits captured for payroll runs.",
  adjustments:
    "Read-only list of adjustments and whether each one is already processed in payroll.",
  createFnf:
    "Create exit settlement input values. Net settlement is derived from earnings minus deductions.",
  fnfRecords:
    "Review and update F&F status. Settled records should be considered final.",
  generateForm16:
    "Generate Form 16 for one employee or all eligible employees for the selected financial year.",
  form16Records:
    "Track generated and issued Form 16 records with earnings and tax totals.",
  bankTransfers:
    "Review transfer batches generated from payroll runs, preview rows, and update processing status.",
  bankPreview:
    "Preview employee-level payout rows, account numbers, and IFSC before bank upload.",
  payslipRecords:
    "Final payslip table with gross, deductions, and net values in rupees. Locked rows are finalized.",
};

export const ManualHint = ({ text }) => (
  <Tooltip
    label={text}
    hasArrow
    placement="top"
    maxW="320px"
    whiteSpace="normal"
  >
    <IconButton
      aria-label="Open quick help"
      icon={<InfoOutlineIcon />}
      size="xs"
      variant="ghost"
      colorScheme="blue"
    />
  </Tooltip>
);

export const CardHeadingWithHelp = ({ title, helpText }) => (
  <HStack spacing={2} align="center">
    <Heading size="md">{title}</Heading>
    <ManualHint text={helpText} />
  </HStack>
);
